var alignment_default = {
  "alignLeft": "yfGVX",
  "textWrapNowrap": "U2Fdj",
  "alignRight": "bVZM8",
  "alignCenter": "YGD94",
  "sizeFullWidth": "B1awJ",
  "renderedInTable": "KCLNk",
  "sizeOriginal": "Rw86A",
  "sizeContent": "_14NsX",
  "sizeSmall": "QG29-",
  "sizeSmallCenter": "kmVXH",
  "flex": "ghyM4",
  "LEFT": "N3-31",
  "CENTER": "-ifIh",
  "RIGHT": "_3KSZi",
  "AUTO": "hRr0S",
  "JUSTIFY": "_37wNA"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
